<template>
  <div class="container">
    <!-- 筛选区域 -->
    <div class="card">
      <div class="card-row" style="flex-direction: column;align-items: flex-start;">
        <div style="font-weight:600;margin-bottom: 12px;">后台管理</div>

        <div class="row">
          <select v-model="filterDept" class="input" style="padding:8px">
            <option value="">全部部门</option>
            <option v-for="d in depts" :key="d" :value="d">{{ d }}</option>
          </select>

          <input
            v-model="filterName"
            placeholder="姓名筛选"
            class="input"
            style="width:140px"
          />

          <button class="button ghost" style="white-space: nowrap;" @click="applyFilter">
            筛选
          </button>
        </div>
      </div>
    </div>

    <!-- 排行区域 -->
    <div class="card">
      <div style="display:flex;flex-direction: column;justify-content:space-between;align-items:flex-start">
        <div style="font-weight:500;margin-bottom: 12px;">综合评分（按 score 排序）</div>
        <div class="muted small">权重：转发率 40% / 线索 60%</div>
      </div>

      <div style="margin-top:12px">
        <div v-if="loading" class="skeleton" style="height:80px;border-radius:10px"></div>

        <div v-else>
          <div
            v-for="(s, idx) in paged"
            :key="idx"
            :class="['rank-item', { first: idx===0, second:idx===1, third:idx===2 }]"
          >
            <div style="display:flex;gap:10px;align-items:center">
              <div class="rank_no">{{ idx + 1 }}</div>
              <div>
                <div style="font-weight:500;margin-bottom: 6px;">
                  {{ s.name }}
                  <span class="muted small">— {{ s.dept }}</span>
                </div>
                <div class="muted small">
                  转发率: {{ (s.forward_rate * 100).toFixed(0) }}% •
                  线索: {{ s.selected_clues }}
                </div>
              </div>
            </div>

            <div style="display:flex;gap:8px;align-items:center">
              <div style="font-weight:500">{{ s.score.toFixed(2) }}</div>
              <button class="button ghost" @click="openEdit(s)">编辑</button>
            </div>
          </div>

          <!-- 分页 -->
          <div style="margin-top:12px;display:flex;justify-content:center;gap:8px;align-items:center">
            <button class="button ghost" @click="prevPage" :disabled="page === 1">上一页</button>

            <div class="muted small">
              第 {{ page }} / {{ totalPage }} 页
            </div>

            <button class="button ghost" @click="nextPage" :disabled="page === totalPage">下一页</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <div
      v-if="editVisible"
      style="position:fixed;left:0;top:0;right:0;bottom:0;background:rgba(10,10,10,0.45);display:flex;align-items:center;justify-content:center;padding:16px"
    >
      <div class="card" style="width:100%;max-width:460px">
        <div style="font-weight:500">编辑综合分数 — {{ editItem.name }}</div>

        <div style="margin-top:8px" class="muted small">
          修改转发率或线索数量，保存后会更新综合评分
        </div>

        <div style="margin-top:12px">
          <label class="small muted">转发率（0-1）</label>
          <input v-model.number="editForward" class="input" type="number" min="0" max="1" step="0.01" />
        </div>

        <div style="margin-top:8px">
          <label class="small muted">线索获选数量</label>
          <input v-model.number="editClues" class="input" type="number" min="0" />
        </div>

        <div style="margin-top:12px;display:flex;justify-content:flex-end;gap:8px">
          <button class="button ghost" @click="closeEdit">取消</button>
          <button class="button" @click="saveEdit">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getScores, updateScore} from "../api/score";
import { toast } from "@/util/toast"

export default {
  name: "ScoreAdmin",

  data() {
    return {
      loading: false,
      list: [],

      depts: ["市场", "运营", "销售", "设计"],
      filterDept: "",
      filterName: "",

      page: 1,
      pageSize: 8,

      editVisible: false,
      editItem: {},
      editForward: 0,
      editClues: 0,
    };
  },

  computed: {
    filtered() {
      let arr = [...this.list];
      if (this.filterDept) arr = arr.filter((i) => i.dept === this.filterDept);
      if (this.filterName) arr = arr.filter((i) => i.name.includes(this.filterName));
      return arr;
    },

    totalPage() {
      return Math.max(1, Math.ceil(this.filtered.length / this.pageSize));
    },

    paged() {
      const start = (this.page - 1) * this.pageSize;
      return this.filtered.slice(start, start + this.pageSize);
    },
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      try {
        this.list = await getScores();
      } catch (err) {
        console.error(err);
        this.list = [];
        toast(err.message || "排行榜加载失败");
      } finally {
        this.loading = false;
      }
    },

    applyFilter() {
      this.page = 1;
    },

    prevPage() {
      if (this.page > 1) this.page--;
    },

    nextPage() {
      if (this.page < this.totalPage) this.page++;
    },

    openEdit(item) {
      this.editItem = item;
      this.editForward = item.forward_rate;
      this.editClues = item.selected_clues;
      this.editVisible = true;
    },

    closeEdit() {
      this.editVisible = false;
    },

    async saveEdit() {
      const u = this.editItem;
      if (!u) return;

      const forward = Number(this.editForward) || 0;
      const clues = Number(this.editClues) || 0;
      const newScore = forward * 0.4 + clues * 0.6;

      u.forward_rate = forward;
      u.selected_clues = clues;
      u.score = newScore;

      try {
        await updateScore(u, {
          forward_rate: forward,
          selected_clues: clues,
        });
        toast("保存成功");
      } catch (e) {
        console.error(e);
        toast(e.message || "保存失败，请重试");
        await this.load();
      } finally {
        this.editVisible = false;
      }
    },
  },
};
</script>

<style scoped>
.container {
    padding: 16px;
    height: calc(100vh - 32px);
    background: linear-gradient(90deg, rgba(150, 226, 251, 0.2) 0%, rgba(183, 171, 236, 0.2) 100%);
}
/* Buttons */
.button {
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 4px;
    background: var(--primary);
    color: #fff;
    border: 0;
    cursor: pointer;
    box-shadow: var(--shadow-xs);
    font-weight: 500;
    white-space: nowrap;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
}

a {
    text-decoration: none;
    color: #fff;
}

.ghost {
    background: transparent;
    color: var(--accent);
    border: 1px solid rgba(0, 160, 255, 0.12);
}

/* Input */
.input {
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #edf2f7;
    background: #fbfdff;
    box-sizing: border-box;
    font-size: 14px;
}

.textarea {
    min-height: 96px;
    resize: vertical;
}

/* Image grid */
.img-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.img-grid img {
    width: 100%;
    height: auto;
}

.img-grid .thumb {
    width: calc(33.333% - 8px);
    aspect-ratio: 1/1;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    background: linear-gradient(180deg, #f8fbff, #eef7ff);
}

.img-grid .thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* thumb overlay (delete button) */
.thumb .delete {
    position: absolute;
    right: 6px;
    top: 6px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 999px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
}

/* Skeleton */
.skeleton {
    background: linear-gradient(90deg, #f0f0f0, #f7f7f7, #f0f0f0);
    background-size: 200% 100%;
    animation: shimmer 1.2s linear infinite;
    border-radius: 8px;
}

.tips {
    color: var(--tips);
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

/* Tiny UI */
.row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.muted {
    color: var(--muted);
    font-size: 13px;
}

.small {
    font-size: 13px;
}

.rank-item.first {
  border-left-color: #f5b100;
  background: #fff8d5;
}
.rank-item.second {
  border-left-color: #b4b7bc;
  background: #f2f4f7;
}
.rank-item.third {
  border-left-color: #c97b45;
  background: #fbeee4;
}
.first .rank_no,
.second .rank_no,
.third .rank_no {
  background-color: transparent;
}

.rank-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px;
  border-bottom: 1px solid #f5f5f5;
  border-left: 4px solid #ffffff;
}

.rank_no {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #e5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}
/* Card */
.card {
    background: var(--card);
    border-radius: var(--radius-lg);
    padding: 14px;
    margin-bottom: 12px;
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    -webkit-border-radius: var(--radius-lg);
    -moz-border-radius: var(--radius-lg);
    -ms-border-radius: var(--radius-lg);
    -o-border-radius: var(--radius-lg);
}

.card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

</style>
